import { useState } from 'react'
import { Link } from 'react-router-dom'
import useSWR from 'swr'
import { api, fetcher } from '../api/client'
import { StatusBadge } from './DashboardPage'

const STATUSES = ['New', 'Contacted', 'Interested', 'Qualified', 'Rejected', 'Converted']

export default function LeadsPage() {
    const [status, setStatus] = useState<string>('')
    const [mineOnly, setMineOnly] = useState(false)

    const qs = new URLSearchParams()
    if (status) qs.set('status', status)
    if (mineOnly) qs.set('mineOnly', 'true')

    const { data, mutate } = useSWR<any>(`/api/leads?${qs}`, fetcher)

    async function changeStatus(id: string, st: string) {
        await api(`/api/leads/${id}`, { method: 'PATCH', body: JSON.stringify({ status: st }) })
        mutate()
    }

    return (
        <div>
            <h1>Leads</h1>

            <div className="card">
                <div className="row">
                    <label style={{ marginBottom: 0 }}>
                        <input type="checkbox" checked={mineOnly} onChange={e => setMineOnly(e.target.checked)} /> My leads only
                    </label>
                    <select value={status} onChange={e => setStatus(e.target.value)}>
                        <option value="">All statuses</option>
                        {STATUSES.map(s => <option key={s} value={s}>{s}</option>)}
                    </select>
                </div>
            </div>

            <div className="card">
                {!data ? <p className="muted">Loading...</p> :
                    data.items?.length === 0 ? <p className="muted">No leads. Rank prospects to populate this list.</p> :
                        <table>
                            <thead><tr><th>Score</th><th>Name</th><th>Company</th><th>Reason</th><th>Status</th><th></th></tr></thead>
                            <tbody>
                                {data.items.map((l: any) => (
                                    <tr key={l.id}>
                                        <td><span className={`score ${scoreClass(l.score)}`}>{l.score}</span></td>
                                        <td><Link to={`/prospects/${l.prospectId}`}>{l.name}</Link></td>
                                        <td>{l.company}</td>
                                        <td className="muted" style={{ maxWidth: 300 }}>{l.rankingReason ?? '—'}</td>
                                        <td><StatusBadge status={l.status} /></td>
                                        <td>
                                            <select value={statusToLabel(l.status)} onChange={e => changeStatus(l.id, e.target.value)}>
                                                {STATUSES.map(s => <option key={s} value={s}>{s}</option>)}
                                            </select>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                }
            </div>
        </div>
    )
}

function scoreClass(s: number) {
    if (s >= 80) return 'score-high'
    if (s >= 60) return 'score-mid'
    return 'score-low'
}

/* normalize int-or-string status from API into a label string */
function statusToLabel(s: string | number): string {
    return typeof s === 'number' ? (STATUSES[s] ?? 'New') : s
}
